<template>
  <div>
    <header>
      <h1 class="page-title">Datos del libro o capítulo</h1>
    </header>
    
    <hr>
    
    <div class="mt-2 mb-4">
      <div class="nav-scroller border-bottom">
        <div class="nav nav-tabs active" ref="tabs">
          <a href="#consult"
             class="nav-link active"
             data-toggle="tab">
            Consultar libro o capítulo</a>
          <a href="#validate"
             class="nav-link"
             data-toggle="tab">
            Validar libro o capítulo</a>
          <a :href="`/curriculo/libro-capitulo/indicador/${task.taskable.id}/editar?url=${currentURL}`"
             class="nav-link">
            Editar libro o capítulo</a>
          <a href="#delete"
             class="nav-link"
             data-toggle="tab"
             @click="showDeleteModal">
            Eliminar libro o capítulo</a>
        </div>
      </div>
    </div>
    
    <div class="tab-content">
      <div class="tab-pane active show" id="consult"
           role="tabpanel"
           aria-labelledby="format-tab-title">
        <div class="w-100" v-if="task.taskable && task.taskable.factor_magazine && task.taskable.factor_magazine.magazine">
          <p class="font-weight-bold h4 text-primary">Revista seleccionada</p>
          
          <div class="w-100">
            <h1 class="h5">{{ task.taskable.factor_magazine.magazine.title }}</h1>
            
            <div>
              <span class="font-weight-bold">ISSN:</span>
              <span>{{ task.taskable.factor_magazine.magazine.issn }}</span>
            </div>
            
            <div>
              <span class="font-weight-bold">Grupo:</span>
              <span>{{ task.taskable.factor_magazine.group }}</span>
            </div>
            
            <div>
              <span class="font-weight-bold">Factor de impacto:</span>
              <span>{{ task.taskable.factor_magazine.impact }}</span>
            </div>
          </div>
        </div>
        
        <hr class="my-4">
        
        <div class="w-100">
          <p class="font-weight-bold h4 text-primary">Datos del libro o capítulo</p>
          <hr>
          <div class="form-group mb-4">
            <p class="font-weight-bold">
              ¿Libro o Capítulo?:
            </p>
            <div class="form-check form-check-inline">
              <input type="radio"
                     class="form-check-input"
                     id="book"
                     name="classified"
                     :value="'libro'"
                     v-model="task.taskable.classified"
                     disabled>
              <label for="book" class="form-check-label font-weight-normal">
                Libro
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio"
                     class="form-check-input"
                     id="chapter"
                     name="classified"
                     :value="'capitulo'"
                     v-model="task.taskable.classified"
                     disabled>
              <label for="chapter" class="form-check-label font-weight-normal">
                Capítulo
              </label>
            </div>
          </div>
          
          <div class="form-group mb-4">
            <label for="book_title">Título del libro:</label>
            <input type="text"
                   name="book_title"
                   id="book_title"
                   v-model="task.taskable.book_title"
                   class="form-control readonly"
                   readonly
                   disabled/>
          </div>

          <div class="form-group mb-4"
               v-if="task.taskable.classified === 'capitulo'">
            <label for="chapter_title">Título del capítulo:</label>
            <input type="text"
                   name="chapter_title"
                   id="chapter_title"
                   v-model="task.taskable.chapter_title"
                   class="form-control readonly"
                   readonly
                   disabled/>
          </div>
          
          <div class="form-group">
            <div class="form-row">
              <div class="col-12 col-md-3 mb-4">
                <label for="publication_year">Año de publicación:</label>
                <input type="text"
                       name="publication_year"
                       id="publication_year"
                       size="4"
                       v-model="task.taskable.publication_year"
                       class="form-control readonly w-auto"
                       readonly
                       disabled/>
              </div>
              
              <div class="col-12 col-md-3 mb-4">
                <label for="edition">Edición:</label>
                <input type="text"
                       name="edition"
                       id="edition"
                       size="10"
                       v-model="task.taskable.edition"
                       class="form-control readonly w-auto"
                       readonly
                       disabled/>
              </div>
              
              <div class="col-12 col-md-3 mb-4">
                <label for="number_of_volumes">Número de volúmenes:</label>
                <input type="text"
                       name="number_of_volumes"
                       id="number_of_volumes"
                       size="2"
                       v-model="task.taskable.number_of_volumes"
                       class="form-control readonly w-auto"
                       readonly
                       disabled/>
              </div>

              <div class="col-12 col-md-3 mb-4"
                   v-if="task.taskable.classified === 'libro'">
                <label for="pages">Páginas:</label>
                <input type="text"
                       name="pages"
                       id="pages"
                       size="2"
                       v-model="task.taskable.pages"
                       class="form-control readonly w-auto"
                       readonly
                       disabled/>
              </div>

              <div class="col-12 col-md-3 mb-4"
                   v-if="task.taskable.classified === 'capitulo'">
                <label for="initial_page">Página inicial:</label>
                <input type="text"
                       name="initial_page"
                       id="initial_page"
                       size="2"
                       v-model="task.taskable.initial_page"
                       class="form-control readonly w-auto"
                       readonly
                       disabled/>
              </div>

              <div class="col-12 col-md-3 mb-4"
                   v-if="task.taskable.classified === 'capitulo'">
                <label for="final_page">Página final:</label>
                <input type="text"
                       name="final_page"
                       id="final_page"
                       size="2"
                       v-model="task.taskable.final_page"
                       class="form-control readonly w-auto"
                       readonly
                       disabled/>
              </div>
            </div>
          </div>

          <div class="form-group mb-4">
            <label for="publication">Publicación:</label>
            <input type="text"
                    name="publication"
                    id="publication"
                    v-model="task.taskable.publication"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="isbn">ISBN:</label>
            <input type="text"
                    name="isbn"
                    id="isbn"
                    v-model="task.taskable.isbn"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="editorial">Editorial:</label>
            <input type="text"
                    name="editorial"
                    id="editorial"
                    size="2"
                    v-model="task.taskable.editorial"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="editor">Editor:</label>
            <input type="text"
                    name="editor"
                    id="editor"
                    size="2"
                    v-model="task.taskable.editor"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="country">País de edición:</label>
            <input type="text"
                    name="country"
                    id="country"
                    size="2"
                    v-model="task.taskable.country_name"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="edition_city">Ciudad de edición:</label>
            <input type="text"
                    name="edition_city"
                    id="edition_city"
                    size="2"
                    v-model="task.taskable.edition_city"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="authors">Autores, tal como aparecen en el capítulo impreso: </label>
            <textarea rows="5"
                      cols="5"
                      name="authors"
                      id="authors"
                      v-model="task.taskable.printed_authors"
                      class="form-control"
                      readonly
                      disabled></textarea>
          </div>

          <div class="form-group mb-4">
            <p class="font-weight-bold">
              ¿En colaboración con INSyHAE?:
            </p>
            <div class="form-check form-check-inline">
              <input type="radio"
                     class="form-check-input"
                     id="insyhae_collaboration_radio_1"
                     name="insyhae_collaboration"
                     :value="1"
                     :checked="task.taskable.institutions"
                     disabled>
              <label for="insyhae_collaboration_radio_1" class="form-check-label font-weight-normal">
                Si
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio"
                     class="form-check-input"
                     id="insyhae_collaboration_radio_2"
                     name="insyhae_collaboration"
                     :value="0"
                     :checked="task.taskable.institutions"
                     disabled>
              <label for="insyhae_collaboration_radio_2" class="form-check-label font-weight-normal">
                No
              </label>
            </div>
          </div>

          <div class="form-group mb-4">
            <label for="volume">Instituciones asignadas:</label>
            <div class="list-group list-group-bordered mt-2" v-if="task.taskable.institutions.length">
              <a href="#"
                 @click.prevent=""
                 class="list-group-item"
                 v-for="institution in task.taskable.institutions"
                 :key="institution.id">
                <div class="list-group-item-body">{{ institution.title }}</div>
              </a>
            </div>
            
            <div v-else class="mt-3">
              <p class="alert alert-warning">No se asignaron instituciones.</p>
            </div>
          </div>

          <div class="form-group mb-4">
            <p class="font-weight-bold">
              El libro es originado por un proyecto del INSP?:
            </p>
            <div class="form-check form-check-inline">
              <input type="radio"
                     class="form-check-input"
                     id="is_insp_origin_radio_1"
                     name="is_insp_origin"
                     :value="1"
                     :checked="task.taskable.protocol"
                     disabled>
              <label for="is_insp_origin_radio_1" class="form-check-label font-weight-normal">
                Si
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio"
                     class="form-check-input"
                     id="is_insp_origin_radio_2"
                     name="is_insp_origin"
                     :value="0"
                     :checked="!task.taskable.protocol"
                     disabled>
              <label for="is_insp_origin_radio_2" class="form-check-label font-weight-normal">
                No
              </label>
            </div>
          </div>

          <div class="form-group mb-4"
               v-if="task.taskable.protocol">
            <label for="volume">Proyecto de investigación:</label>
            <input type="text"
                    name="volume"
                    id="volume"
                    size="2"
                    v-model="task.taskable.protocol.title"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4"
               v-else>
            <label for="justification">Justificación: </label>
            <textarea rows="5"
                      cols="5"
                      name="justification"
                      id="justification"
                      v-model="task.taskable.justification"
                      class="form-control"
                      readonly
                      disabled></textarea>
          </div>

          <div class="form-group mb-4">
            <p class="font-weight-bold">
              ¿El artículo incorpora la perspectiva de género?:
            </p>
            <div class="form-check form-check-inline">
              <input type="radio"
                     class="form-check-input"
                     id="has_gender_perspective_radio_1"
                     name="has_gender_perspective"
                     :value="1"
                     v-model="task.taskable.has_gender_perspective"
                     disabled>
              <label for="has_gender_perspective_radio_1" class="form-check-label font-weight-normal">
                Si
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input type="radio"
                     class="form-check-input"
                     id="has_gender_perspective_radio_2"
                     name="has_gender_perspective"
                     :value="0"
                     v-model="task.taskable.has_gender_perspective"
                     disabled>
              <label for="has_gender_perspective_radio_2" class="form-check-label font-weight-normal">
                No
              </label>
            </div>
          </div>

          <div class="form-group mb-4"
               v-if="task.taskable.has_gender_perspective">
            <label for="volume">Señale cuáles aspectos aplican (puede ser más de uno):</label>
            <div class="form-check">
              <input type="checkbox"
                     class="form-check-input"
                     name="aspects_gender_perspective"
                     v-model="task.taskable.aspects_gender_perspective"
                     :value="'El libro/capítulo reporta información desagregada para hombres y mujeres.'"
                     disabled>
              <label class="form-check-label">
                El libro/capítulo reporta información desagregada para hombres y mujeres.
              </label>
            </div>
            <div class="form-check">
              <input type="checkbox"
                     class="form-check-input"
                     name="aspects_gender_perspective"
                     v-model="task.taskable.aspects_gender_perspective"
                     :value="'El proyecto reporta información que hace visible las brechas entre hombres y mujeres.'"
                     disabled>
              <label class="form-check-label">
                El proyecto reporta información que hace visible las brechas entre hombres y mujeres.
              </label>
            </div>
            <div class="form-check">
              <input type="checkbox"
                     class="form-check-input"
                     name="aspects_gender_perspective"
                     v-model="task.taskable.aspects_gender_perspective"
                     :value="'El proyecto hace visible inequidades o vulnerabilidades especificas de las mujeres.'"
                     disabled>
              <label class="form-check-label">
                El proyecto hace visible inequidades o vulnerabilidades especificas de las mujeres.
              </label>
            </div>
            <div class="form-check">
              <input type="checkbox"
                     class="form-check-input"
                     name="aspects_gender_perspective"
                     v-model="task.taskable.aspects_gender_perspective"
                     :value="'El proyecto reporta información sobre problemáticas que afectan mayoritariamente a la salud y/o bienestar de las mujeres (por ejemplo: cancer de mama o cervico uterino, lactancia, embarazo en adolescencia, aborto, etc).'"
                     disabled>
              <label class="form-check-label">
                El proyecto reporta información sobre problemáticas que afectan mayoritariamente a la salud y/o bienestar de las mujeres (por ejemplo: cancer de mama o cervico uterino, lactancia, embarazo en adolescencia, aborto, etc).
              </label>
            </div>
          </div>

          <div class="form-group mb-4">
            <label for="research_line">Línea de investigación:</label>
            <input type="text"
                    name="research_line"
                    id="research_line"
                    size="2"
                    :value="task.taskable.research_line ? task.taskable.research_line.title : ''"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="research_subline">Sublínea de investigación:</label>
            <input type="text"
                    name="research_subline"
                    id="research_subline"
                    size="2"
                    :value="task.taskable.research_subline ? task.taskable.research_subline.title : ''"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="research_type">Área de investigación: </label>
            <input type="text"
                   name="research_type"
                   id="research_type"
                   :value="task.taskable.research_type ? task.taskable.research_type.title : ''"
                   class="form-control"
                   readonly
                   disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="volume">Demanda sector:</label>
            <input type="text"
                    name="volume"
                    id="volume"
                    size="2"
                    :value="task.taskable.demand ? task.taskable.demand.title : ''"
                    class="form-control readonly"
                    readonly
                    disabled/>
          </div>

          <div class="form-group mb-4">
            <label for="volume">Comprobante Seleccionado:</label>
            <br>
            <template v-if="task.taskable.file_path">
              <i class="fas fa-file-pdf text-danger"></i>
              <a :href="`/${task.taskable.file_path}`" target="_blank">{{ task.taskable.file_name }}</a>
            </template>
            <template v-else>
              Sin comprobante
            </template>
          </div>

          <div class="form-group mb-4">
            <label for="volume">Alumnos asignados:</label>
            <div class="list-group list-group-bordered mt-2" v-if="task.taskable.students.length">
              <a href="#"
                 @click.prevent=""
                 class="list-group-item list-group-item-action"
                 v-for="student in task.taskable.students"
                 :key="student.id">
                <div class="list-group-item-figure">
                  <div class="user-avatar">
                    <img :src="student.avatar" :alt="student.full_name">
                  </div>
                </div>
                <div class="list-group-item-body">{{student.full_name}}</div>
              </a>
            </div>
            
            <div v-else class="mt-3">
              <p class="alert alert-warning">No se asignaron alumnos.</p>
            </div>
          </div>

          <div class="form-group mb-4">
            <label for="volume">Autores asignados:</label>
            <div class="list-group list-group-bordered mt-2" v-if="task.taskable.authors.length">
              <a href="#"
                 @click.prevent=""
                 class="list-group-item list-group-item-action"
                 v-for="author in task.taskable.authors"
                 :key="author.id">
                <div class="list-group-item-figure">
                  <div class="user-avatar">
                    <img :src="author.avatar" :alt="author.full_name">
                  </div>
                </div>
                <div class="list-group-item-body">
                  {{author.full_name}}
                  <br>
                  <span class="badge text-sm badge-info">{{ participationTitles[author.pivot.participation_type] }}</span>
                  </div>
              </a>
            </div>
            
            <div v-else class="mt-3">
              <p class="alert alert-warning">No se asignaron autores.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-pane" id="validate"
           role="tabpanel"
           aria-labelledby="format-tab-title">

        <form id="frm-validate"
              ref="frm-validate"
              accept-charset="UTF-8"
              onsubmit="return false">
          <div v-if="task.classification.key === 'revision_libro_subdirector_academico'">
            <div class="form-group mb-4">
              <p class="font-weight-bold">
                  ¿Aprobado para enviar al Comité de investigación?: *
              </p>
              <div class="form-check form-check-inline">
                <input type="radio"
                      id="validated_true"
                      name="validated"
                      class="form-check-input"
                      value="1"
                      v-model="validated">
                <label for="validated_true"
                      class="form-check-label font-weight-normal">Si</label>
              </div>
              <div class="form-check form-check-inline">
                  <input type="radio"
                      id="validated_false"
                      name="validated"
                      class="form-check-input"
                      value="0"
                      v-model="validated">
                <label for="validated_false"
                      class="form-check-label font-weight-normal">No</label>
              </div>
              <div data-name="validated"></div>
            </div>
          </div>
          <div v-else>
            <div class="form-group mb-4">
              <p class="font-weight-bold">
                  ¿Incluir el libro o capítulo en indicadores?: *
              </p>
              <div class="form-check form-check-inline">
                <input type="radio"
                      id="is_included_on_indicators_true"
                      name="is_included_on_indicators"
                      class="form-check-input"
                      value="1"
                      v-model="isIncludedOnIndicators">
                <label for="is_included_on_indicators_true"
                      class="form-check-label font-weight-normal">Si</label>
              </div>
              <div class="form-check form-check-inline">
                  <input type="radio"
                      id="is_included_on_indicators_false"
                      name="is_included_on_indicators"
                      class="form-check-input"
                      value="0"
                      v-model="isIncludedOnIndicators">
                <label for="is_included_on_indicators_false"
                      class="form-check-label font-weight-normal">No</label>
              </div>
              <div data-name="is_included_on_indicators"></div>
            </div>
            <div class="form-group mb-4">
              <p class="font-weight-bold">
                  ¿Es Open Access?: *
              </p>
              <div class="form-check form-check-inline">
                <input type="radio"
                      id="is_open_access_true"
                      name="is_open_access"
                      class="form-check-input"
                      value="1"
                      v-model="isOpenAccess">
                <label for="is_open_access_true"
                      class="form-check-label font-weight-normal">Si</label>
              </div>
              <div class="form-check form-check-inline">
                  <input type="radio"
                      id="is_open_access_false"
                      name="is_open_access"
                      class="form-check-input"
                      value="0"
                      v-model="isOpenAccess">
                <label for="is_open_access_false"
                      class="form-check-label font-weight-normal">No</label>
              </div>
              <div data-name="is_open_access"></div>
            </div>
          </div>
          <div class="form-group mb-4">
            <label for="comments">Comentarios:</label>
            <textarea rows="5"
                      cols="5"
                      name="comments"
                      id="comments"
                      class="form-control"
                      v-model="comments"></textarea>
          </div>
          <button class="btn btn-lg btn-primary mr-2"
                  type="submit">Validar
          </button>
        </form>

      </div>

      <portal to="protocol-modals">
        <ok-cancel-dialog id="delete-modal"
                          ref="delete-modal"
                          title="Eliminar libro o capítulo"
                          content="<p>¿Esta seguro de eliminar este libro o capítulo?</p>"
                          ok-button-text="Eliminar"
                          @ok-button-pressed="deleteBookChapterIndicator"></ok-cancel-dialog>

        <ok-cancel-dialog id="validate-modal"
                          ref="validate-modal"
                          title="Validar libro o capítulo"
                          :content="modalMessage"
                          ok-button-text="Validar"
                          @ok-button-pressed="validate"></ok-cancel-dialog>
      </portal>
    </div>
  </div>
</template>

<script>
  import 'jquery-validation'
  import FilesList from '../protocols/FilesList'
  import ProtocolHeader from '../protocols/commons/ProtocolHeader'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import autosize from 'autosize'
  import { mapActions } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  
  export default {
    name: 'ValidateBookChapter',
    components: {
      OkCancelDialog,
      FilesList,
      ProtocolHeader,
    },
    props: {
      protocol: Object,
      task: Object,
    },
    methods: {
      ...mapActions({
        validateBookChapter: 'bookschapters/validateBookChapter',
        validateBookChapterByResearchCommittee: 'bookschapters/validateBookChapterByResearchCommittee',
        deleteBookChapter: 'bookschapters/deleteBookChapter',
      }),

      showDeleteModal() {
        $('#delete-modal').modal('show')
      },

      async deleteBookChapterIndicator() {
        this.$refs['delete-modal'].sending = true

        const response = await this.deleteBookChapter({
          bookChapter: this.task.taskable.id,
          task_id: this.task.id,
        })
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
        }
        else {
          AlertManager.error(response.error)
        }

        this.$refs['delete-modal'].sending = false
        this.$refs['delete-modal'].close()
        location.href = '/dashboard';
      },

      async validate() {
        this.$refs['validate-modal'].sending = true

        if (this.task.classification.key === 'revision_libro_subdirector_academico') {
          const response = await this.validateBookChapter({
            bookChapter: this.task.taskable.id,
            validated: this.validated,
            comments: this.comments,
            task_id: this.task.id,
          })
          
          if (response.status === 'success') {
            AlertManager.success(response.message)
          }
          else {
            AlertManager.error(response.error)
          }
        } else {
          const response = await this.validateBookChapterByResearchCommittee({
            bookChapter: this.task.taskable.id,
            is_included_on_indicators: this.isIncludedOnIndicators,
            is_open_access: this.isOpenAccess,
            comments: this.comments,
            task_id: this.task.id,
          })
          
          if (response.status === 'success') {
            AlertManager.success(response.message)
          }
          else {
            AlertManager.error(response.error)
          }
        }

        this.$refs['validate-modal'].sending = false
        this.$refs['validate-modal'].close()
        location.href = '/dashboard';
      }
    },
    data () {
      return {
        format: null,
        saving: false,
        title: '',
        content: '',
        okButtonText: '',
        validated: '',
        isIncludedOnIndicators: '',
        isOpenAccess: '',
        comments: '',
        participationTitles: {
          principal: 'Principal',
          principal_insp: 'Principal Interno INSP',
          coautor: 'Coautor',
          correspondencia: 'Correspondencia',
        },
        modalMessage: '',
      }
    },
    computed: {
      currentURL() {
        return encodeURIComponent(window.location.href)
      },
    },
    mounted () {
      const vm = this

      autosize($('textarea'))

      $('#frm-validate').validate({
        highlight: function(element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function(label, element) {
          label.addClass('invalid-feedback')

          if (element.is(':radio')) {
            label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            label.insertAfter(element)
          }
        },
        rules: {
          validated: {
            required: function(element) {
              return vm.task.classification.key === 'revision_libro_subdirector_academico';
            },
          },
          is_included_on_indicators: {
            required: function(element) {
              return vm.task.classification.key !== 'revision_libro_subdirector_academico';
            },
          },
          is_open_access: {
            required: function(element) {
              return vm.task.classification.key !== 'revision_libro_subdirector_academico';
            },
          },
          comments: {
            required: true,
          },
        },
        messages: {
          validated: {
            required: 'Este campo es requerido.',
          },
          is_included_on_indicators: {
            required: 'Este campo es requerido.',
          },
          is_open_access: {
            required: 'Este campo es requerido.',
          },
          comments: {
            required: 'Este campo es requerido.',
          },
        },
        submitHandler(form) {
          const title = vm.task.taskable.classified === 'capitulo' ? vm.task.taskable.chapter_title : vm.task.taskable.book_title;
          
          if (parseInt(vm.isIncludedOnIndicators)) {
            vm.modalMessage = `¿Está seguro de incluir el libro o capítulo <b>${title}</b> en indicadores?`
          } else {
            vm.modalMessage = `¿Está seguro de no incluir el libro o capítulo <b>${title}</b> en indicadores?`
          }

          $('#validate-modal').modal('show')
        },
      })
    },
  }
</script>
